export const RECEIVED_NEXT_STEP_PROGRESS = 'RECEIVED_NEXT_STEP_PROGRESS';

const getNextStepProgress = () => (
  (dispatch) => {
    if (window.nextStepProgress) {
      dispatch({
        type: RECEIVED_NEXT_STEP_PROGRESS,
        nextStepProgress: window.nextStepProgress,
      });
    }
  }
);

export default getNextStepProgress;
